import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import Services from "@/components/landing/Services";
import ApplicationForm from "@/components/landing/ApplicationForm";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#08070D] text-[#F9FAFB] overflow-x-hidden">
      <div className="grain" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <ApplicationForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
